// src/constants/themePresets.js
export const DEFAULT_THEMES = {
  modern: {
    name: "Modern",
    colors: {
      primary: '#2563eb',
      secondary: '#1e40af',
      accent: '#f59e0b',
      background: '#ffffff',
      text: '#1f2937',
      textLight: '#6b7280'
    },
    typography: {
      primary: 'Inter, sans-serif',
      secondary: 'Georgia, serif',
      baseSize: '16px'
    }
  },
  elegant: {
    name: "Elegant",
    colors: {
      primary: '#7c3aed',
      secondary: '#5b21b6',
      accent: '#ec4899',
      background: '#fafafa',
      text: '#374151',
      textLight: '#9ca3af'
    }
  },
  vibrant: {
    name: "Vibrant",
    colors: {
      primary: '#dc2626',
      secondary: '#b91c1c',
      accent: '#ea580c',
      background: '#ffffff',
      text: '#000000',
      textLight: '#4b5563'
    }
  }
};